import { CreateProps } from 'react-admin';
import { CustomCreate } from '../../components';
import Form from './form';

export default function AwardsCreate(props: CreateProps) {
  return (
    <CustomCreate {...props}>
      <Form />
    </CustomCreate>
  );
}
